import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { toast } from "react-toastify";
import axios from "../utils/axios";
import { DashboardState } from "./type";
// import { toast } from '@ravenpay/raven-bank-ui';
// import { AuthState } from "./types"

export const getTransactionMetrics = createAsyncThunk(
  "web/get-transaction-metrics",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/dashboard/transaction?interval=${payload?.interval || "year"}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_TRANSACTION_METRICS(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getTransactionMetricsCounts = createAsyncThunk(
  "web/get-transaction-metrics-counts",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/dashboard/totals`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        //   console.log(obj);
        thunkAPI.dispatch(SET_CUSTOMER_TRANSACTION(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getCurrencyExchangeMetrics = createAsyncThunk(
  "web/get-currency-exchange-metrics",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/dashboard/exchange-rate?interval=${payload?.interval || "year"}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        //   console.log(obj);
        thunkAPI.dispatch(SET_CURRENCY_EXCHANGE_METRICS(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getCustomerMetrics = createAsyncThunk(
  "web/get-customer-single",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `admin/dashboard/customer?interval=${payload?.interval || "year"}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_METRICS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: DashboardState = {
  loading_customer: false,
  loading_transaction: false,
  customer_metric: {},
  transaction_metric: {},
  currency_exchange_metric: [],
  loading_currency_exchange: false,
  cus_trans_info: {},
  // initialize other state properties
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,

  reducers: {
    SET_TRANSACTION_METRICS: (state, action) => {
      state.transaction_metric = action.payload;
    },
    SET_CUSTOMER_METRICS: (state, action) => {
      state.customer_metric = action.payload;
    },
    SET_CURRENCY_EXCHANGE_METRICS: (state, action) => {
      state.currency_exchange_metric = action.payload;
    },
    SET_CUSTOMER_TRANSACTION: (state, action) => {
      state.cus_trans_info = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getTransactionMetrics.pending, (state) => {
      state.loading_transaction = true;
    });
    builder.addCase(getTransactionMetrics.fulfilled, (state) => {
      state.loading_transaction = false;
    });
    builder.addCase(getTransactionMetrics.rejected, (state) => {
      state.loading_transaction = false;
      return initialState;
    });
    builder.addCase(getCustomerMetrics.pending, (state) => {
      state.loading_customer = true;
    });
    builder.addCase(getCustomerMetrics.fulfilled, (state) => {
      state.loading_customer = false;
    });
    builder.addCase(getCustomerMetrics.rejected, (state) => {
      state.loading_customer = false;
      return initialState;
    });
    builder.addCase(getCurrencyExchangeMetrics.pending, (state) => {
      state.loading_currency_exchange = true;
    });
    builder.addCase(getCurrencyExchangeMetrics.fulfilled, (state) => {
      state.loading_currency_exchange = false;
    });
    builder.addCase(getCurrencyExchangeMetrics.rejected, (state) => {
      state.loading_currency_exchange = false;
      return initialState;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_CUSTOMER_METRICS,
  SET_TRANSACTION_METRICS,
  SET_CURRENCY_EXCHANGE_METRICS,
  SET_CUSTOMER_TRANSACTION,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
